import queryString from 'query-string';
import SignAction from 'actions/SignAction';
class Ajax {

    _appendQuery(uri, query) {
        const querystring = queryString.stringify(query),
            prefix = uri.indexOf('?') === -1 ? '?' : '&';
        return uri + prefix + querystring;
    }

    /**
     * [call description]
     * @param  {[type]} options [description]
     * @return {[type]}         [description]
     */
    call(options) {
        const responseType = options.responseType || 'json',
            fetchOptions = {
                method: options.method || 'GET',
                headers: new Headers(options.headers || {})
            };

        let fetchUrl = options.url;

        if (responseType === 'json') {
            fetchOptions.headers.append('Accept', 'application/json');
        }

        // Add query arguments to URL
        if (options.params) {
            fetchUrl = Ajax._appendQuery(fetchUrl, options.params);
        }

        // Add body
        if (typeof options.json === 'object') {
            fetchOptions.headers.append('Content-Type', 'application/json');
            fetchOptions.body = JSON.stringify(options.json);
        }

        // Call API
        return fetch(fetchUrl, fetchOptions).then(response => {
            // Manage errors
            if (response.status === 401 && fetchUrl.indexOf('auth') === -1)
                SignAction.logout(true);

            if (responseType === 'json') {
                return response;
            }
            return null;
        }, err => {
            throw err;
        });
    }
}

export default new Ajax();
